import type { ReactNode, RefAttributes } from "react";
import type * as lazyFunctions from "./lazyFunctions";
import { type LazyComponent, LazyModule, createLazyComponent } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyFunctions> = new LazyModule(() => import(/* webpackChunkName: "CalendarBootGroupsPanel" */ "./lazyFunctions"), { name: "CalendarBootGroupsPanel" });

export const GroupsPanelContainer: LazyComponent<{
    children?: ReactNode | undefined;
} & RefAttributes<unknown>, unknown, void> = createLazyComponent(lazyModule, m => m.GroupsPanelContainer);
export const GroupsPanelHeader: LazyComponent<{
    children?: ReactNode | undefined;
} & RefAttributes<unknown>, unknown, void> = createLazyComponent(lazyModule, m => m.GroupsPanelHeader);
